// extracted by mini-css-extract-plugin
export var legendIndicator = "_gc-1";
export var legendRight = "_gc-0";